import { gql } from "@apollo/client";

export const lensPayoutHistory = gql`
    query lensPayoutHistory($lensId: ID!) {
        lensPayoutHistory(input: { lensId: $lensId }) {
            totalEarningsMilliUsd
            lastPayoutDate
        }
    }
`;
